import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@material-ui/core";
import httpClient from "../../../lib/httpClient";
import { DisplayField, DisplayFieldSameLine } from "../../util/DisplayField";
import { formatDateTimeValue } from "../../util/tableUtils";

export const EmergencyEventDescription = (props: { event: TerraShieldEvent }) => {
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());
  const [statusIsClosed, setStatusIsClosed] = useState<boolean>(false);

  const [damageComputed, setDamageComputed] = useState<Date>(new Date(2025, 0, 1));
  const { event } = props;
  useEffect(() => {
    const getEventUpdateInfo = async () => {
      const { data } = await httpClient().get(`terrashield/overview`);

      setLastUpdate(
        data.data.filter((an_event: TerraShieldOverview) => an_event.code === event.code)[0].lastUpdate,
      );

      setStatusIsClosed(
        data.data.filter((an_event: TerraShieldOverview) => an_event.code === event.code)[0].closed,
      );

      const damageComputedLocal = data.data.filter(
        (an_event: TerraShieldOverview) => an_event.code === event.code,
      )[0]?.damageComputed;
      if (damageComputedLocal) {
        // Otherwise, it will be set to 2025-01-01
        setDamageComputed(damageComputedLocal);
      }
    };
    if (event.code) getEventUpdateInfo();
  }, [event.code]);

  const { t } = useTranslation();

  return (
    <Box p={1}>
      <DisplayFieldSameLine label={t("emergencyMonitoring.code")} value={event.code} />
      <DisplayFieldSameLine label={t("emergencyMonitoring.name")} value={event.name} />
      <DisplayField label={t("emergencyMonitoring.description")} value={event.reason} />
      <DisplayFieldSameLine label={t("emergencyMonitoring.category")} value={event.category} />
      <DisplayFieldSameLine
        label={t("emergencyMonitoring.eventTime")}
        value={formatDateTimeValue(event.eventTime)}
      />
      <DisplayFieldSameLine
        label={t("emergencyMonitoring.currentStatus")}
        value={
          statusIsClosed
            ? t("emergencyMonitoring.statusWasClosed")
            : t("emergencyMonitoring.statusWasOngoing")
        }
      />
      <DisplayField label={t("emergencyMonitoring.lastUpdate")} value={formatDateTimeValue(lastUpdate)} />
      <DisplayField
        label={t("emergencyMonitoring.damageComputed")}
        value={formatDateTimeValue(damageComputed)}
      />
    </Box>
  );
};
